import {ChangeDetectorRef, HostBinding,Component,ViewEncapsulation, OnInit, OnDestroy,SimpleChanges,AfterViewInit } from '@angular/core';
import { FormGroup, FormControl, FormArray } from "@angular/forms";
import * as _ from "lodash";
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {MessageService} from '../../message.service';
import {AppSettings} from '../../settings';
import {BaseComponent} from '../base/base.component';
import {UserpermissionService} from '../../services/userpermission.service';
import {HomeService} from '../../services/home.service';
import {IRule} from '../../irule';

declare var $:any;//Required for jquery use

@Component({
  selector: 'app-user-set-permission',
  templateUrl: './user-set-permission.component.html',
  styleUrls: ['./user-set-permission.component.css'],
  encapsulation:ViewEncapsulation.None
})
export class UserSetPermissionComponent extends BaseComponent implements OnInit,OnDestroy,AfterViewInit,IRule  {

  url:any=AppSettings.API_ENDPOINT;

  @HostBinding('style.width') public width: string = '100%'; //for edge browser design issue

   constructor(msg:MessageService,  homeservice:HomeService,toastr: ToastrService, _router: Router, private userpermissionService:UserpermissionService) {   		
		   
	   super(msg,toastr,homeservice,_router);
	   this.msg = msg;
	   this.toastr = toastr;
	   this._router =_router;
   }

  userPermissionList: any = [];
  msg:any;
  toastr:any;
  _router:any;
  userName:any;
  token:any='';

  notification:any=[];

  permissionForm: any;
  selectedPermissions: [string];
  mypermissions: any = [];

  roles:any=[];

  save_roles:any=[];

  navigationsType:any =[];
  
  loader_image:boolean=true;

 

  ngOnInit() {

	try{
		
		let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;
		if(!tokenA) throw 'Error in parse';
		if(!JSON.parse(tokenA)) throw 'Error in json parse';
		tokenA = JSON.parse(tokenA);
		this.token = tokenA.token;

		let data = { 
			token:tokenA.token,
			page:'users' 

			//limit:this.per_page,				
		}

 
		this.userpermissionService.roleList(data).subscribe( (roleres)=>{	
		if(roleres.status=='success'){	
		 
			this.userName=roleres.user.name;

			this.navigationsType=roleres.navigation;

			this.notification= roleres.notification;
			
			this.broadcast_menu();
			

		// this.msg.sendMessage({'user':roleres.name,'type':'left_menu_link','navigations':roleres.navigation});

		if(roleres.permissions)
		{ 


		for (let i = 0; i < roleres.permissions.length; i++) {
		//console.log(roleres.permissions[i]);


		this.roles.push( { 'role': roleres.permissions[i].role ,'permission': roleres.permissions[i].permission} );
        this.save_roles.push( { 'role': roleres.permissions[i].role ,'permission': []} );

	
		} 

          
		
		this.userpermissionService.permissionList(data).subscribe( (res)=>{			
		    if(res.status=='success'){
				
				this.loader_image =false;
		    	if(res.permissions)
		    	{		    		
		    		for (let i = 0; i < res.permissions.length; i++) {

						let dP=[];

						dP['name']= res.permissions[i].value;
						dP['value']= res.permissions[i].key;
				
						this.roles.forEach(element => {
							 
							dP[element.role] = (element.permission.indexOf(res.permissions[i].key) !== -1) ? true : false;


						});
						

		    			this.mypermissions.push(dP);
		    		}
	          		//console.log(this.mypermissions);
	          		this.createFormInputs();
		    	}

		    	 
	        }else{        
	          	this.toastr.error(res.message, '', {timeOut: 5000});
	        }
	    });




		}
		}
		});

		



	}catch(error){
		this._router.navigate(['/login']);
	}
  }

  ngAfterViewInit(){

  }


 back(){

 
	this._router.navigate(['/users']);


 }


  createFormInputs() {
	  
	this.loader_image=false;

    this.permissionForm = new FormGroup({
      permissions: this.createPermissions(this.mypermissions)
    });
   
  }

  createPermissions(permissionsInputs) {

    const arr = permissionsInputs.map(

    	loopkey => {

			 let p:any=[];

			 this.roles.forEach(element => {

                p[element.role] = new FormControl( loopkey[element.role] || false) 

			 }); 
			
	      return  new FormGroup( p) ;	      
	    }
    );
    return new FormArray(arr);
  }

  saveUserpermission()
  {
		 

		  	
	  	for(let i = 0; i < this.permissionForm.controls.permissions.value.length; i++)
	  	{
			  

            this.save_roles.forEach( (role,j) => {

				if(this.permissionForm.controls.permissions.value[i][role.role])
				{
						
					this.save_roles[j].permission.push(this.mypermissions[i].value);
					
				}

				
			});

	
			  		
		  }
		  



	  		let data  = {
	  			token : this.token,
				  "permissions": this.save_roles,
				  'page':'users'
	  		}
	
			  
	  		this.userpermissionService.savepermissionList(data).subscribe( (res)=>{			
			
				if(res.status=='success'){

			 

				this.toastr.success('Permission added Successfully', '', {timeOut: 5000});

				this._router.navigate(['/users']);
				
			     

	        }else{        
	          	this.toastr.error(res.message, '', {timeOut: 5000});
	        }
		});	
		
		
  }
  broadcast_menu(){
    
	this.msg.sendMessage({'user':this.userName,'notification':this.notification,'type':'left_menu_link','navigations':this.navigationsType});
  
  }

}
